import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import moment from 'moment';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _ from 'lodash';
import { usersLoaded } from '../../actions';
import { checkLoggedIn, validateAccess } from '../../session';
import { analyticsActions } from '../../webapi';
import { getPluralS } from '../../helper';
import { UTC_OFFSET } from '../../config';
import { compileStats, getInsight, getAnalyticsFilterOptions } from '../../js';
import { AnalyticsFilter } from '../../components';
import { Text } from '../../components/text';

class OffersHubAnalytics extends Component {
  constructor(props) {
    super(props);
    const filterOptions = getAnalyticsFilterOptions();
    const selectedFilter = filterOptions[1];
    this.state = {
      loading: true,
      stats: {},
      totalStats: {},
      previousStats: null,
      selectedFilter: filterOptions[1],
      currentDayCount: selectedFilter.dayCount,
    };
  }

  UNSAFE_componentWillMount() {
    checkLoggedIn(this, this.props.auth);
  }

  componentDidMount() {
    if (!validateAccess(this.props.auth.site, 'offers', this.props.auth, true)) {
      this.props.history.push('/mastermenu');
    } else {
      this.getStats();
    }
  }

  getTotalStat(key) {
    if (!this.state.totalStats[key]) {
      return 0;
    }
    if (Array.isArray(this.state.totalStats[key])) {
      return this.state.totalStats[key].length;
    }
    return this.state.totalStats[key];
  }

  getStat(id, key) {
    if (!this.state.stats[id]) {
      return 0;
    }
    if (!this.state.stats[id][key]) {
      return 0;
    }
    if (Array.isArray(this.state.stats[id][key])) {
      return this.state.stats[id][key].length;
    }
    return this.state.stats[id][key];
  }

  getStats(min, max) {
    this.setState({
      loading: true,
    });
    const lastDay = max ? moment(max).utc() : moment.utc();
    const dayCount = min ? moment(max).diff(moment(min), 'days') : this.state.selectedFilter.dayCount;
    console.log(`getStats: lastDay:${moment(lastDay).format('DD/MM/YYYY')}, dayCount:${dayCount}`);

    const startOfLastDay = lastDay.utcOffset(UTC_OFFSET).startOf('d');
    const minTime = moment(startOfLastDay).add(-dayCount, 'd').valueOf() - 1;
    const maxTime = moment(startOfLastDay).valueOf() - 1;

    analyticsActions.getAggregateEntityStats(this.props.auth.site, 'offer', minTime, maxTime).then((res) => {
      console.log(res.data);
      console.log(compileStats(res.data));
      this.setState({
        stats: res.data,
        totalStats: compileStats(res.data),
        loading: false,
        currentDayCount: dayCount,
      });
      const prevMinTime =
        moment(startOfLastDay)
          .add(2 * -dayCount, 'd')
          .valueOf() - 1;
      analyticsActions.getAggregateEntityStats(this.props.auth.site, 'offer', prevMinTime, minTime).then((oldRes) => {
        console.log(oldRes.data);
        console.log(compileStats(oldRes.data));
        this.setState({
          previousStats: oldRes.data,
          previousTotalStats: compileStats(oldRes.data),
        });
      });
    });
  }

  filterChanged = (selectedFilter) => {
    this.setState({ selectedFilter }, () => {
      this.getStats();
    });
  };

  filterDateRangeChanged = (startDate, endDate) => {
    this.getStats(startDate, endDate);
  };

  renderStats() {
    if (this.state.loading) {
      return null;
    }
    return (
      <div className="eventanalytics--overview paddingTop-40">
        <Text type="formTitleSmall" className="marginBottom-16">
          Overview
        </Text>
        <div className="polloverview polloverview--eventAnalytics">
          <div className="polloverview_section">
            <FontAwesome className="polloverview_icon" name="eye" />
            <div className="polloverview_right">
              <p className="polloverview_count">{this.getTotalStat('PageView')}</p>
              <p className="polloverview_text">Page View{getPluralS(this.getTotalStat('PageView'))}</p>
            </div>
          </div>
          <div className="polloverview_section">
            <FontAwesome className="polloverview_icon" name="user" />
            <div className="polloverview_right">
              <p className="polloverview_count">{this.getTotalStat('UniquePageView')}</p>
              <p className="polloverview_text">Unique Visitor{getPluralS(this.getTotalStat('UniquePageView'))}</p>
            </div>
          </div>
          <div className="polloverview_section">
            <FontAwesome className="polloverview_icon" name="undo" />
            <div className="polloverview_right">
              <p className="polloverview_count">{this.getTotalStat('PageView') - this.getTotalStat('UniquePageView')}</p>
              <p className="polloverview_text">
                Returning Visitor{getPluralS(this.getTotalStat('PageView') - this.getTotalStat('UniquePageView'))}
              </p>
            </div>
          </div>
          <div className="polloverview_section">
            <FontAwesome className="polloverview_icon" name="link" />
            <div className="polloverview_right">
              <p className="polloverview_count">{this.getTotalStat('UrlClick')}</p>
              <p className="polloverview_text">Click{getPluralS(this.getTotalStat('UrlClick'))}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderInsight(offer, title, primaryStat) {
    if (!offer || !offer.Entity || !offer.Stats) {
      return null;
    }
    const currentStat = offer.Stats && offer.Stats[primaryStat] ? offer.Stats[primaryStat] : 0;
    const prevStat = offer.PreviousStats && offer.PreviousStats[primaryStat] ? offer.PreviousStats[primaryStat] : 0;
    const change = currentStat - prevStat;
    const prevText = this.state.selectedFilter.prevText.replace('*', this.state.currentDayCount);

    return (
      <div className="insights">
        <div className="insightstitle">
          <Text type="formTitleSmall">{title}</Text>
          <div className="hrline"></div>
        </div>
        <div className="insights_section">
          <div className="insightsimg" alt="" style={{ backgroundImage: `url('${offer.Entity.Image}')` }}></div>
          <div className="insightsright">
            <p className="fontMedium fontSize-26 text-dusk lineClamp-2">{offer.Entity.Title}</p>
            {change === 0 ? (
              <p className="fontHeavy fontSize-13 text-brandingAction">No change on {prevText}</p>
            ) : (
              <p className="fontHeavy fontSize-13 text-brandingAction">
                <FontAwesome className="insightsstat" name={`caret-${change > 0 ? 'up' : 'down'}`} />
                <b>
                  {change} on {prevText}
                </b>
              </p>
            )}

            <div className="insightsnumber">
              <div className="insightsnumleft">
                <p className="polloverview_text marginBottom-8 text-mid">Page View{getPluralS(offer.Stats.PageView)}</p>
                <p className="polloverview_text marginBottom-8 text-mid">Click{getPluralS(offer.Stats.UrlClick)}</p>
              </div>
              <div className="insightsnumright">
                <p className="polloverview_num marginBottom-8">{offer.Stats.PageView || 0}</p>
                <p className="polloverview_num marginBottom-8">{offer.Stats.UrlClick || 0}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderInsights() {
    if (this.state.loading) {
      return null;
    }
    const mostViewed = getInsight(this.state.stats, this.state.previousStats, this.props.offers, 'Id', 'PageView');
    const mostClicked = getInsight(this.state.stats, this.state.previousStats, this.props.offers, 'Id', 'UrlClick');
    if (!mostViewed && !mostClicked) {
      return null;
    }
    return (
      <div className="serviceanalytics--insights paddingTop-40">
        <Text type="formTitleSmall" className="marginBottom-16">
          Insights
        </Text>

        <div className="insightscontainer">
          {this.renderInsight(mostViewed, 'Most Viewed', 'PageView')}
          {this.renderInsight(mostClicked, 'Most Clicked', 'UrlClick')}
        </div>
      </div>
    );
  }

  renderOfferList() {
    if (this.state.loading) {
      return null;
    }
    return (
      <div className="servicelisttable paddingTop-40">
        <Table className="plussTable" striped bordered condensed hover style={{ minWidth: '100%' }}>
          <thead>
            <tr>
              <th>Title</th>
              <th>Page Views</th>
              <th>Clicks</th>
            </tr>
          </thead>
          <tbody>
            {_.sortBy(_.sortBy(this.props.offers, 'Title'), (offer) => {
              return this.getStat(offer.Id, 'PageView');
            })
              .reverse()
              .map((offer) => {
                if (!this.state.stats[offer.Id]) {
                  return null;
                }
                return (
                  <tr key={offer.Id}>
                    <td>{offer.Title}</td>
                    <td>{this.getStat(offer.Id, 'PageView')}</td>
                    <td>{this.getStat(offer.Id, 'UrlClick')}</td>
                  </tr>
                );
              })}
          </tbody>
        </Table>
      </div>
    );
  }

  renderFilter() {
    return (
      <AnalyticsFilter
        defaultFilter={this.state.selectedFilter}
        filterChanged={this.filterChanged}
        filterDateRangeChanged={this.filterDateRangeChanged}
      />
    );
  }

  render() {
    return (
      <div style={{ minWidth: '100%' }}>
        <p className="fontMedium fontSize-36 text-dark">Analytics</p>
        {this.renderFilter()}
        {this.renderStats()}
        {this.renderInsights()}
        {this.renderOfferList()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { auth } = state;
  return {
    auth,
  };
};

export default connect(mapStateToProps, { usersLoaded })(withRouter(OffersHubAnalytics));
